export default __webpack_public_path__ + "static/media/gs8-checkout.434380c9.jpg";